/**
 * Fallback only when the admin left min width / height / depth empty.
 * A customizable placeholder with no min must still accept small sizes;
 * 1mm rejects 0 and negatives without inventing a 100mm floor.
 */
export const PLACEHOLDER_MIN_SIZE_MM = 1;

export const lowerLimit = (min?: number | null): number =>
    min != null && min > 0 ? min : PLACEHOLDER_MIN_SIZE_MM;

export const upperLimit = (max?: number | null): number | null =>
    max != null && max > 0 ? max : null;

/**
 * Same copy as a cabinet size field: say the limit, do not change the value.
 *
 * @param {string} label Field name, e.g. Width.
 * @param {number} value Entered size in mm.
 * @param {number|null|undefined} min Lower limit, if the admin set one.
 * @param {number|null|undefined} max Upper limit, if the admin set one.
 * @return {string|null} The cabinet-style error, or null when the value is allowed.
 */
export const dimensionLimitError = (
    label: string,
    value: number,
    min?: number | null,
    max?: number | null
): string | null => {
    const lower = lowerLimit(min);
    const upper = upperLimit(max);

    if (value < lower) {
        return `${label} cannot be less than ${lower}`;
    }
    if (upper != null && value > upper) {
        return `${label} cannot be more than ${upper}`;
    }
    return null;
};
